import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardsComponent } from './dashboards.component';


const routes: Routes = [
  {
    path: '',
    component: DashboardsComponent,
    children: [
      { path: 'tasks', loadChildren: () => import('./masters/tasks/tasks.module').then(m => m.TasksModule) },
      { path: 'users', loadChildren: () => import('./masters/users/users.module').then(m => m.UsersModule) },
      { path: 'external-users', loadChildren: () => import('./masters/external-users/external-users.module').then(m => m.ExternalUsersModule) },
      { path: 'countries', loadChildren: () => import('./masters/countries/countries.module').then(m => m.CountriesModule) },
      { path: 'regions', loadChildren: () => import('./masters/regions/regions.module').then(m => m.RegionsModule) },
      { path: 'cities', loadChildren: () => import('./masters/cities/cities.module').then(m => m.CitiesModule) },
      { path: 'airports', loadChildren: () => import('./masters/airports/airports.module').then(m => m.AirportsModule) },
      { path: 'fleet', loadChildren: () => import('./masters/fleet/fleet.module').then(m => m.FleetModule) },
      { path: 'operators', loadChildren: () => import('./masters/operators/operators.module').then(m => m.OperatorsModule) },
      { path: 'contacts', loadChildren: () => import('./masters/contacts/contacts.module').then(m => m.ContactsModule) },
      { path: 'service-list', loadChildren: () => import('./masters/services/services.module').then(m => m.ServicesModule) },
      { path: 'conditions', loadChildren: () => import('./masters/conditions/conditions.module').then(m => m.ConditionsModule) },
      { path: 'contract-templates', loadChildren: () => import('./masters/contract-templates/contract-templates.module').then(m => m.ContractTemplatesModule) },
      { path: 'cost-templates', loadChildren: () => import('./masters/cost-templates/cost-templates.module').then(m => m.CostsModule) },
      { path: 'service-categories', loadChildren: () => import('./masters/service-categories/service-categories.module').then(m => m.ServiceCategoriesModule) },
      { path: 'aircraft-plate-numbers', loadChildren: () => import('./masters/aircraft-plate-numbers/aircraft-plate-numbers.module').then(m => m.AircraftPlateNumbersModule) },
      { path: 'files', loadChildren: () => import('./files/files.module').then(m => m.FilesModule) },
      { path: 'delays', loadChildren: () => import('./masters/delays/delays.module').then(m => m.DelaysModule) },
      { path: 'statistics', loadChildren: () => import('./masters/statistics/statistics.module').then(m => m.StatisticsModule) },
      { path: 'fuel-price', loadChildren: () => import('./masters/fuel-price/fuel-price.module').then(m => m.FuelPriceModule)},
      { path: 'ssr', loadChildren: () => import('./masters/ssr/ssr.module').then(m => m.SsrModule) },
      { path: 'pnl', loadChildren: () => import('./masters/pnl/pnl.module').then(m => m.PnlModule) },
      { path: 'language-templates', loadChildren: () => import('./masters/language-templates/language-templates.module').then(m => m.LanguageTemplatesModule) },
      { path: 'offer-templates', loadChildren: () => import('./masters/offer-templates/offer-templates.module').then(m => m.OfferTemplatesModule)},
      { path: 'preparation-templates', loadChildren: () => import('./masters/preparation-templates/preparation-templates.module').then(m => m.PreparationTemplatesModule)},
      { path: 'preparation-tasks', loadChildren: () => import('./masters/preparation-tasks/preparation-tasks.module').then(m => m.PreparationTasksModule)}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
